export type WhitelabelDomain = 'auvo' | 'chatshub' | 'iterup' | 'poli';

export function getWhitelabelFromDomain(
  hostname: string = window.location.hostname
) {
  if (hostname.includes('auvo')) return 'auvo';
  if (hostname.includes('chatshub')) return 'chatshub';
  if (hostname.includes('iterup')) return 'iterup';
  return 'poli';
}
